import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { formatDateDMY, formatDateTimeDMY } from './utils/date';

// Global date format override: dd-mm-yyyy across the app
Date.prototype.toLocaleDateString = function () {
  return formatDateDMY(this);
};
Date.prototype.toLocaleString = function () {
  return formatDateTimeDMY(this);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
